import { NewTab, PageTabAdv } from "../../../components";
import { useModuleAccess } from "../../../hooks";
import { useLoginUser } from "../../../hooks/useLoginUser";
import { getItem } from "../../../utils/localStorageUtils";
import AccessControl from "./AccessControl/AccessControl";
import CompanyProfile from "./CompanyProfile/CompanyProfile";
import Configurations from "./Configurations/Configurations";
import NotificationCenter from "./NotificationCenter/NotificationCenter";


const BENCH_USER_MODULE = 4; 
const Settings = () => {
  const portal = getItem("portal");
  const { userData: loginUserData } = useLoginUser();
  const moduleNumber = loginUserData?.role?.module;
  const isBenchUser = BENCH_USER_MODULE===moduleNumber; 


  const SettingsMenus = [
    {
      title: "Company Profile",
      page: <CompanyProfile />,
      type: "main",
      id: "settings_companyprofile",
    },

    //  Showing Configurations ONLY if NOT bench user
    !isBenchUser && {
      title: "Configurations",
      page: <Configurations />,
      type: "main",
      id: "settings_configurations",
    },

    {
      title: "Access Control",
      page: <AccessControl />,
      type: "main",
      id: "settings_accesscontrol",
    },
    {
      title: "Notification Center",
      page: <NotificationCenter />,
      type: "main",
      disabled: true,
      id: "settings_notificationcenter",
    },
  ].filter(Boolean);

  const filteredTabs = useModuleAccess({
    allTabs: SettingsMenus,
    parentId: "settings",
    accessKey:
      portal === "bs" ? "benchsales" : portal === "wf" ? "workforce" : "ats",
  });
  return (
    <div className="flex-1 flex  overflow-hidden">
      <NewTab
        tabs={filteredTabs}
        color="black"
        variant="outlined"
        mode="url"
        tabId="settings"
      />
    </div>
  );
};

export default Settings;
